import axios from 'axios';
import React,{useState, useEffect} from 'react';

const ShopCategory = (props) => {
    const [shopData, setShopData] = useState([]);
    const colorString = Object.values(props.theme).toString();
    const getShopData = async () => {
     const result = await  axios.get('https://appi.colexion.io/api/Shopby');
     setShopData(result.data[0])
    }
    useEffect(() =>{
        getShopData();
    }, [])
    return (
        <section className={colorString === 'true'?`shopCategory customSec dark`: `shopCategory customSec whiteTheme`}>
            <div className="container">
                <div className="sectionHeading justify-content-center text-center">
                    <div className="d-block">
                        <h2>SHOP BY CATEGORY</h2>
                        <h3>Explore and purchase a variety of creatives and stars Memorabilia</h3>
                    </div>
                </div>
                <div className="shopCategoryList">
                    {
                        shopData.curl
                        ?
                        <a href={shopData.curl} target="_blank" rel="noreferrer">
                            <div className="shopCategoryBx">
                                <img src={process.env.PUBLIC_URL + '/images/homepage/celebrities.svg'} alt="" />
                                <h4>celebrities</h4>
                            </div>
                        </a>
                        :
                        null
                        
                    }
                    {
                        shopData.surl
                        ?
                        <a href={shopData.surl} target="_blank" rel="noreferrer">
                            <div className="shopCategoryBx">
                                <img src={process.env.PUBLIC_URL + '/images/homepage/sports.svg'} alt="" />
                                <h4>sports</h4>
                            </div>
                        </a>
                        :
                        null
                        
                    }
                    
                    
                    {
                        shopData.aurl
                        ?
                        <a href={shopData.aurl} target="_blank" rel="noreferrer">
                            <div className="shopCategoryBx">
                                <img src={process.env.PUBLIC_URL + '/images/homepage/art.svg'} alt="" />
                                <h4>art</h4>
                            </div>
                        </a>
                        :
                        null
                        
                    }
                    {
                        shopData.lurl
                        ?
                        <a href={shopData.lurl} target="_blank" rel="noreferrer">
                            <div className="shopCategoryBx">
                                <img src={process.env.PUBLIC_URL + '/images/homepage/lifestyle.svg'} alt="" />
                                <h4>lifestyle</h4>
                            </div>
                        </a>
                        :
                        null
                        
                    }
                    
                    
                </div>
            </div>
        </section>
    )
}
export default ShopCategory;